<template>
  <div id="app-div" style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="5">
            <label>出版年份：</label>
            <a-select class="query_input" v-model="queryYear">
              <a-select-option
                v-for="item in yearList"
                :key="item"
                :value="item"
              >
                {{ item }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="5">
            <label>出版期次：</label>
            <a-select class="query_input" v-model="queryCount" allowClear="">
              <a-select-option
                v-for="item in selPlanList"
                :key="item.total"
                :value="item.total"
              >
                {{ `总第${item.total}期` }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="5">
            <label>状态：</label>
            <a-select class="query_input" v-model="queryStatus">
              <a-select-option value="0">全部</a-select-option>
              <a-select-option value="1">待提交</a-select-option>
              <a-select-option value="2">待审核</a-select-option>
              <a-select-option value="3">审核拒绝</a-select-option>
            </a-select>
          </a-col>
          <a-button type="primary" class="query_btn" @click="getPublishPlan">
            查询
          </a-button>
        </a-row>
      </div>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
      <div class="sortType" style="float: right">
        排序方式：
        <a-select
          size="small"
          defaultValue="1"
          style="width: 120px"
          @change="sortChange"
          v-model="sort"
        >
          <a-select-option value="1">编号降序</a-select-option>
          <a-select-option value="2">编号升序</a-select-option>
          <a-select-option value="3">时间降序</a-select-option>
          <a-select-option value="4">时间升序</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :rowSelection="rowSelection"
          :columns="issueingColumns"
          :dataSource="planList"
          :rowKey="(record) => record.planCode"
          size="small"
          :scroll="{ y: planList.length < 8 ? false : table_height }"
          bordered
        >
          <span slot="operator" slot-scope="text, record">
            <!-- <a
              href="javascript:void(0);"
              @click="() => edit(record)"
              v-if="record.status == '0'"
            >
              组稿
            </a> -->
            <a
              href="javascript:void(0);"
              @click="() => showConfirm(record)"
              v-if="record.status == '0'"
            >
              确认稿件列表
            </a>
            <template v-if="record.status == '1' || record.status == '4'">
              <a href="javascript:void(0);" @click="() => edit(record)">编辑</a>
              <a-divider type="vertical" />
              <a
                href="javascript:void(0);"
                @click="() => uploadPublishFile(record)"
              >
                上传清样
              </a>
              <a-divider type="vertical" />
              <a href="javascript:void(0);" @click="() => submit(record)">
                提交
              </a>
            </template>
            <a
              href="javascript:void(0);"
              @click="() => royalties(record)"
              v-if="record.status == '5'"
            >
              稿费登记表
            </a>
            <a-divider type="vertical" />
            <a
              href="javascript:void(0);"
              @click="() => auditPaper(record)"
              v-if="record.status == '5'"
            >
              稿件送审单
            </a>
          </span>
          <span slot="total" slot-scope="text, record">
            <label>总第{{ record.total }}期</label>
          </span>
          <span slot="status" slot-scope="text, record">
            <label v-if="record.status == '0'">
              <img class="status_img" src="../../../../assets/open.png" />未组稿
            </label>
            <label v-if="record.status == '1'">
              <img class="status_img" src="../../../../assets/open.png" />待提交
            </label>
            <label v-if="record.status == '2'">
              <img
                class="status_img"
                src="../../../../assets/open.png"
              />副主编审核中
            </label>
            <label v-if="record.status == '3'">
              <img
                class="status_img"
                src="../../../../assets/open.png"
              />主编审核中
            </label>
            <label v-if="record.status == '4'">
              <img
                class="status_img"
                src="../../../../assets/close.png"
              />审核拒绝
            </label>
            <label v-if="record.status == '5'">
              <img
                class="status_img"
                src="../../../../assets/open.png"
              />审核通过
            </label>
          </span>
          <span slot="paperStatus" slot-scope="text, record">
            <label v-if="record.paperStatus == 0">未生成</label>
            <label v-if="record.paperStatus == 1">已生成</label>
            <label v-if="record.paperStatus == 2">生成中</label>
            <label v-if="record.paperStatus == 3">生成失败</label>
          </span>
        </a-table>
      </div>
      <a-select
        defaultValue="0"
        style="margin-top: 5px; float: left"
        @change="operateChange"
        v-model="operateCode"
      >
        <a-select-option value="0">批量操作</a-select-option>
        <a-select-option value="1">批量导出</a-select-option>
      </a-select>
    </div>
    <a-modal
      title="上传清样"
      v-model="publishFileVisible"
      @ok="publishFileOk"
      :centered="true"
      :destroyOnClose="true"
      :maskClosable="false"
      width="350px;"
    >
      <div>
        <label>请点击上传本期的PDF图样文件</label>
      </div>
      <div>
        <a-upload
          name="file"
          :action="uploadAddress"
          :headers="headers"
          @change="uploadFile"
          :remove="fileRemove"
          :data="publishFileData"
          accept=".pdf"
        >
          <a-button> <a-icon type="upload" />选择文件 </a-button>
        </a-upload>
      </div>
    </a-modal>
    <a-modal
      title="组稿"
      v-model="visible"
      :dialog-style="{ top: '10px' }"
      :bodyStyle="{ height: 'calc(100vh - 90px)' }"
      width="98%"
      :footer="null"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <PublishInfoSet :publishRecord="currRecord" @publishBack="publishBack" />
    </a-modal>
    <a-modal
      title="确认稿件列表"
      class="confirmList"
      v-model="confirmVisible"
      :dialog-style="{ top: '0' }"
      :bodyStyle="{ height: 'calc(100vh - 105px)' }"
      width="100%"
      :confirm-loading="confirmLoading"
      @ok="handleConfirmOk"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <ConfirmManuscript ref="confirmItem" :publishRecord="currRecord" />
    </a-modal>
    <a-modal
      title="作者稿费登记表"
      v-model="royaltiesVisible"
      :dialog-style="{ top: '10px' }"
      width="1200px"
      :footer="null"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <PublishRoyalties
        :publishRecord="currRecord"
        @publishBack="publishBack"
      />
    </a-modal>
  </div>
</template>
<script>
//待签发
const issueingColumns = [
  {
    title: "排刊编号",
    dataIndex: "publishCode",
  },
  {
    title: "年份",
    dataIndex: "year",
  },
  {
    title: "期次",
    dataIndex: "total",
    scopedSlots: { customRender: "total" },
  },
  {
    title: "版本",
    dataIndex: "sectionInfo",
  },
  {
    title: "操作人",
    dataIndex: "creater",
  },
  {
    title: "时间",
    dataIndex: "createTime",
  },
  // {
  //   title: '状态',
  //   dataIndex: 'status',
  //   scopedSlots: { customRender: 'status' }
  // },
  {
    title: "送审单",
    dataIndex: "paperStatus",
    scopedSlots: { customRender: "paperStatus" },
  },
  {
    title: "操作",
    key: "operator",
    width: 200,
    scopedSlots: { customRender: "operator" },
  },
];

import qs from "qs";
import PublishInfoSet from "./PublishInfoSet.vue";
import PublishRoyalties from "./PublishRoyalties.vue";
import ConfirmManuscript from "./ConfirmManuscript.vue";
export default {
  data() {
    return {
      serviceAddress: this.$config.serviceAddress,
      uploadAddress: this.$config.serviceAddress + "/file/upload",
      headers: {
        authorization: "authorization-text",
      },
      publishFileData: {
        fileType: "qingYang",
      },
      visible: false,
      yearList: [],
      selPlanList: [],
      planList: [],
      issueingColumns,
      selectedRowKeys: [],
      queryYear: "",
      queryCount: "",
      queryStatus: "0",
      statusList: [1, 2, 3, 4, 5],
      publishFileVisible: false,
      fileList: [],
      sort: "1",
      publishCode: "",
      sortField: "publish_code",
      sortType: "desc",
      operateCode: "0",
      page: 1,
      limit: 20,
      total: 0,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
      currRecord: {},
      royaltiesVisible: false,
      confirmVisible: false,
      confirmLoading: false,
    };
  },
  components: {
    PublishInfoSet,
    PublishRoyalties,
    ConfirmManuscript,
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        columnWidth: 35,
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        onSelection: this.onSelection,
      };
    },
  },
  created() {
    this.axios.get("/publishPlan/queryYear").then((res) => {
      this.yearList = res.data;
    });
    this.queryYear = new Date().getFullYear().toString();
    this.getPublishPlan();
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;
  },
  methods: {
    getPublishPlan() {
      this.axios
        .get("/publishPlan/queryPublishPlan", {
          params: {
            year: this.queryYear,
            total: this.queryCount,
            sortField: "total",
            sortType: "asc",
            page: 1,
            limit: 100,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.planList = res.data.data;
            this.planList.forEach((item) => {
              this.$set(item, "publishCode", "");
              this.$set(item, "sectionInfo", "");
              this.$set(item, "paperStatus", "");
              item.creater = "";
              item.createTime = "";
              item.status = "0";
            });
            if (this.queryYear == "" || this.queryCount == "") {
              this.selPlanList = res.data.data;
            }

            this.query();
          } else {
            this.utils.messageInfo(this, "error", "查询出版计划列表失败！");
          }
        });
    },
    uploadFile(info) {
      this.fileList = [];
      if (info.fileList.length == 2) {
        info.fileList.splice(0, 1);
      }
      let fileList = [...info.fileList];
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });
      this.fileList = fileList;
      if (info.file.status !== "uploading") {
        this.fileList = info.fileList;
      }
      if (info.file.status === "done") {
        this.utils.messageInfo(this, "success", "上传成功");
      } else if (info.file.status === "error") {
        this.utils.messageInfo(this, "error", "上传失败");
      }
    },
    fileRemove(file) {
      this.fileList = [];
      var data = file.response;
      if (data.code == "OK") {
        this.axios.post("/file/deleteFile", {
          url: data.data.realFilePath,
        });
      }
    },
    uploadPublishFile(record) {
      // if (record.status == 4) {
      //   this.utils.messageInfo(this, 'error', '审核中，无法执行该操作！');
      //   return;
      // }
      this.fileList = [];
      this.publishFileVisible = true;
      this.publishCode = record.publishCode;
    },
    publishFileOk() {
      var fileList = [];
      for (var i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].response.code == "OK") {
          fileList.push(this.fileList[i].response.data);
        }
      }
      if (fileList.length == 0) {
        this.utils.messageInfo(this, "error", "请上传清样！");
        return;
      }
      this.axios
        .post("/detailFiles/saveDetailFiles", {
          publishCode: this.publishCode,
          fileList: JSON.stringify(fileList),
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "上传清样成功！");
            this.publishFileVisible = false;
          } else {
            this.utils.messageInfo(this, "error", "关联失败！");
          }
        });
    },
    submit(record) {
      // if (record.status == 4) {
      //   this.utils.messageInfo(this, 'error', '审核中，无法执行该操作！');
      //   return;
      // }
      if (record.status == 2) {
        this.utils.messageInfo(this, "error", "请勿重复提交！");
        return;
      }
      var codes = [];
      codes.push(record.publishCode);
      this.axios
        .post("/publishInfo/changeStatus", {
          codes: JSON.stringify(codes),
          status: 2,
          creater: sessionStorage.getItem("userCode"),
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "提交成功");
            this.getPublishPlan();
          } else {
            this.utils.messageInfo(this, "error", "提交失败！");
          }
        });
    },
    edit(record) {
      // if (record.status == 4) {
      //   this.utils.messageInfo(this, "error", "审核中，无法执行该操作！");
      //   return;
      // }
      this.currRecord = { ...record };
      this.visible = true;
    },
    sortChange() {
      if (this.sort == 1) {
        this.sortField = "publish_code";
        this.sortType = "desc";
      } else if (this.sort == 2) {
        this.sortField = "publish_code";
        this.sortType = "";
      } else if (this.sort == 3) {
        this.sortField = "create_time";
        this.sortType = "desc";
      } else if (this.sort == 4) {
        this.sortField = "create_time";
        this.sortType = "";
      }
      this.getPublishPlan();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    operateChange() {
      var itemLegth = this.selectedRowKeys.length;
      if (itemLegth == 0) {
        this.utils.messageInfo(this, "error", "最少选择一条数据！");
        return;
      }
      if (this.operateCode == 1) {
        if (this.serviceAddress == "") {
          this.utils.messageInfo(
            this,
            "error",
            "获取后台ip地址失败，无法导出！"
          );
          return;
        }
        var selectedRowKeys = this.selectedRowKeys;
        window.open(
          this.serviceAddress +
            "/publishInfo/exportData?codeArr=" +
            selectedRowKeys +
            ""
        );
      }
    },
    query() {
      this.axios
        .get("/publishInfo/queryPublishInfo", {
          params: {
            year: this.queryYear,
            count: this.queryCount,
            status: this.queryStatus,
            statusList: this.statusList.join(","),
            sortField: this.sortField,
            sortType: this.sortType,
            page: 1,
            limit: 100,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.planList.forEach((item) => {
              let fin = res.data.data.find(
                (d) => item.year == d.year && item.total == d.count
              );
              if (fin) {
                item.publishCode = fin.publishCode;
                item.sectionInfo = fin.sectionInfo;
                item.creater = fin.creater;
                item.createTime = fin.createTime;
                item.status = fin.status;
                item.auditPaper = fin.auditPaper;
                item.paperStatus = fin.paperStatus;
                item.paperError = fin.paperError;
              }
            });
          } else {
            this.utils.messageInfo(this, "error", "查询稿件列表失败！");
          }
        });
    },
    publishBack() {
      this.currRecord = {};
      this.getPublishPlan();
      this.visible = false;
      this.royaltiesVisible = false;
    },
    royalties(record) {
      this.currRecord = record;
      this.royaltiesVisible = true;
    },
    auditPaper(record) {
      if (record.paperStatus == 0) {
        this.$confirm({
          title: "提示",
          content: "稿件送审单未生成，是否生成送审单？",
          okText: "确认",
          cancelText: "取消",
          onOk: () => {
            this.axios
              .get("/publishInfo/createAuditPaper", {
                params: { publishCode: record.publishCode },
              })
              .then((res) => {
                if (res.data.code == "OK") {
                  this.utils.messageInfo(
                    this,
                    "success",
                    "送审单生成中，请稍后刷新下载"
                  );
                  setTimeout(this.getPublishPlan(), 500);
                } else {
                  this.utils.messageInfo(this, "error", "生成送审单失败！");
                }
              });
          },
        });
      } else if (record.paperStatus == 1) {
        window.open(this.serviceAddress + record.auditPaper);
      } else if (record.paperStatus == 2) {
        this.utils.messageInfo(this, "warning", "送审单生成中，请稍后刷新下载");
      }
    },
    showConfirm(record) {
      this.currRecord = record;
      this.confirmVisible = true;
    },
    handleConfirmOk() {
      let res = this.$refs.confirmItem.confirmList();
      if (res) {
        this.$confirm({
          title: "提示",
          content: res.hasSameCompany
            ? "有稿件来自同一单位，是否继续？"
            : "是否确认本期次稿件？",
          okText: "确认",
          cancelText: "取消",
          onOk: () => {
            this.confirmLoading = true;
            let formData = {
              publishInfo: {
                publishCode: this.currRecord.publishCode,
                periodicalCode: this.currRecord.periodicalCode,
                year: this.currRecord.year,
                total: this.currRecord.total,
                sectionInfo: res.sectionInfo,
              },
              selectedColumn: res.selectedColumn,
              fileList: [],
              status: 5,
              creater: sessionStorage.getItem("userCode"),
            };
            if (!this.currRecord.publishCode) {
              this.axios
                .post("/publishInfo/savePublishInfo", formData)
                .then((res) => {
                  this.confirmLoading = false;
                  if (res.data.code == "OK") {
                    this.utils.messageInfo(this, "success", "添加成功");
                    this.currRecord = {};
                    this.confirmVisible = false;
                    this.getPublishPlan();
                  } else {
                    this.utils.messageInfo(this, "error", "添加失败！");
                  }
                });
            } else {
              this.axios
                .post("/publishInfo/updatePublishInfo", formData)
                .then((res) => {
                  this.confirmLoading = false;
                  if (res.data.code == "OK") {
                    this.utils.messageInfo(this, "success", "编辑成功");
                    this.currRecord = {};
                    this.confirmVisible = false;
                    this.getPublishPlan();
                  } else {
                    this.utils.messageInfo(this, "error", "编辑失败！");
                  }
                });
            }
          },
          onCancel: () => {},
        });
      }
    },
  },
};
</script>
<style>
@import "../../../../assets/css/PageCss.css";
</style>
<style>
.status_img {
  width: 18px;
  margin-right: 6px;
  margin-bottom: 3px;
}
.confirmList .ant-modal-wrap {
  overflow: hidden !important;
}
.confirmList .ant-modal-content .ant-modal-footer {
  text-align: center;
}
</style>
